import { FilterInfo } from "@lhd/features/Apps/AppList/ManagementAppSheet/ManagementAppSheetList/AppSheetComponents/FilterIcon";
import { useCallback, useState, SetStateAction } from "react";

const DEFAULT_FILTER_INFO: FilterInfo = {
  open: false,
  columnId: null as string | null,
  position: { x: 0, y: 0 },
};

const useFilterPanel = (props: {
  onChangeOpenFilter?: (filterInfo: FilterInfo) => void;
  filterInfo?: FilterInfo;
}) => {
  const { onChangeOpenFilter, filterInfo: controlledFilterInfo } = props;
  const [internalFilterInfo, setInternalFilterInfo] =
    useState<FilterInfo>(DEFAULT_FILTER_INFO);

  const isControlled = controlledFilterInfo !== undefined;
  const filterInfo = isControlled ? controlledFilterInfo : internalFilterInfo;

  const handleSetFilterInfo = useCallback(
    (action: SetStateAction<FilterInfo>) => {
      const newFilterInfo =
        typeof action === "function" ? action(filterInfo) : action;
      const merged = { ...filterInfo, ...newFilterInfo };
      if (!isControlled) {
        setInternalFilterInfo(merged);
      }
      onChangeOpenFilter?.(merged);
    },
    [filterInfo, isControlled, onChangeOpenFilter],
  );

  return {
    filterInfo,
    handleSetFilterInfo,
  };
};

export default useFilterPanel;
